import { HERO_IMG } from "@/data/site";

export default function Hero() {
  return (
    <section id="top" className="bg-[#f8fafc] text-[#0f172a] pt-12 pb-20 border-b border-slate-200 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-7 space-y-6">
            <div className="inline-flex items-center gap-2 px-3 py-1 bg-blue-100 text-[#1e3a8a] rounded text-xs font-bold uppercase tracking-widest">
              <span className="w-1.5 h-1.5 rounded-full bg-[#1e3a8a]" aria-hidden="true" />
              <span>Italian Technique Specialists • 37 Mumbai Zones</span>
            </div>

            <h1 className="display-font text-3xl sm:text-4xl lg:text-5xl leading-[0.95] tracking-tight uppercase text-[#0f172a]">
              <span className="ln"><span>FLAWLESS ITALIAN</span></span>
              <span className="ln"><span>MARBLE POLISHING.</span></span>
            </h1>

            <p className="d1-sub text-lg sm:text-xl text-slate-600 max-w-xl font-normal leading-relaxed">
              Italian technique mirror finish and precision hairline crack filling across Mumbai residences, societies, and architect projects.
            </p>

            <div className="d1-ctrl flex flex-wrap gap-4 pt-2">
              <a
                data-testid="hero-book-inspection-btn"
                href="#contact"
                className="px-8 py-4 bg-[#1e3a8a] hover:bg-[#1e40af] text-white font-bold text-sm tracking-wider uppercase rounded shadow-lg transition-colors"
              >
                Book Site Inspection
              </a>
              <a
                data-testid="hero-view-work-btn"
                href="#gallery"
                className="px-7 py-4 bg-white border border-slate-300 hover:border-slate-400 text-slate-800 font-bold text-sm tracking-wider uppercase rounded transition-colors"
              >
                View Verified Work
              </a>
            </div>

            <div className="pt-8 grid grid-cols-3 gap-4 border-t border-slate-200">
              <div data-testid="hero-stat-mirror">
                <span className="mono-font block text-2xl font-bold text-[#1e3a8a]">100%</span>
                <span className="text-xs uppercase tracking-wider font-semibold text-slate-500">Mirror Clarity</span>
              </div>
              <div data-testid="hero-stat-zones">
                <span className="mono-font block text-2xl font-bold text-[#1e3a8a]">37+</span>
                <span className="text-xs uppercase tracking-wider font-semibold text-slate-500">Mumbai Pin Codes</span>
              </div>
              <div data-testid="hero-stat-gst">
                <span className="mono-font block text-2xl font-bold text-[#1e3a8a]">GST</span>
                <span className="text-xs uppercase tracking-wider font-semibold text-slate-500">Registered Firm</span>
              </div>
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="bg-white p-3 border-2 border-slate-900 rounded-lg shadow-xl relative">
              <div className="d1-wipe">
                <figure className="relative aspect-[4/3] rounded overflow-hidden">
                  <img
                    src={HERO_IMG}
                    alt="Pristine mirror finish Italian marble floor in a Mumbai residence after diamond polishing"
                    className="absolute inset-0 w-full h-full object-cover"
                    loading="eager"
                  />
                  <div className="relative flex flex-col justify-between h-full p-5">
                    <div className="flex justify-between items-center w-full">
                      <span className="px-2.5 py-1 bg-[#1e3a8a] text-white text-[10px] font-bold tracking-widest uppercase rounded">Italian Marble</span>
                      <span className="px-2.5 py-1 bg-emerald-600 text-white text-[10px] font-bold tracking-widest uppercase rounded">Mirror Polished</span>
                    </div>
                    <figcaption className="text-xs uppercase tracking-widest font-bold text-slate-800 bg-white/90 backdrop-blur-sm p-3 rounded">
                      Italian Marble Diamond Crystallization • Mirror Finish
                    </figcaption>
                  </div>
                </figure>
              </div>
              <div className="mt-3 flex items-center justify-between px-2 text-xs font-semibold text-slate-600">
                <span>Italian Diamond Pad Multi-Stage</span>
                <span className="text-[#1e3a8a] font-bold">100% Gloss Depth</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
